import { render, staticRenderFns } from "./ContractResolver.vue?vue&type=template&id=08a6f23d&scoped=true&"
import script from "./ContractResolver.vue?vue&type=script&lang=js&"
export * from "./ContractResolver.vue?vue&type=script&lang=js&"
import style0 from "./ContractResolver.vue?vue&type=style&index=0&id=08a6f23d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a6f23d",
  null
  
)

export default component.exports